module.exports = __webpack_public_path__ + "static/media/kn.3212905f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kn.png
// module id = 1898
// module chunks = 0